import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './an_chart.scss';
const isValidBranchAwareUhid = value => /^(ASCAS|VDASCAS)\d+$/i.test((value || '').trim());

export default function AnChart(props) {
  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };

  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [showTables, setShowTables] = useState({
    medication: true
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });
   const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'time', label: 'Time'},
    {key: 'duration', label: 'Duration'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Inj.TDVAC 1st Dose',
      genericName: 'SII TD-Vac Vaccine',
      dose: 'as advised',
      frequency: '-',
      time: '-',
      duration: 'as advised'
    },
    {
      sno: '2',
      drug: 'Inj.TDVAC 2st Dose',
      genericName: 'SII TD-Vac Vaccine',
      dose: 'as advised',
      frequency: '-',
      time: '-',
      duration: 'as advised'
    },
   {
      sno: '3',
      drug: 'Inj.Boostrix',
      genericName: 'Diphtheria toxoid',
      dose: 'as advised',
      frequency: '-',
      time: '-',
      duration: 'as advised'
    },
     {
      sno: '4',
      drug: 'Inj.Influvac tetra',
      genericName: ' Quadrivalent Seasonal Influenza Vaccine',
      dose: 'as advised',
      frequency: '-',
      time: '-',
      duration: 'as advised'
    },
     {
      sno: '5',
      drug: 'Inj.ANTI D',
      genericName: 'Rho(D) immune globulin',
      dose: 'as advised',
      frequency: '-',
      time: '-',
      duration: 'as advised'
    },
    
  ]);

  const handleChange = e => {
    // const { name, value } = e.target;
    // setvalueChange({ ...valueChange, [name]: value });
    var text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (isValidBranchAwareUhid(e.target.value)) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value
          });
        }
      }
    } else {
      console.log('Going in');
      setvalueChange({...valueChange, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    props.loaderchange('true');
    try {
      if (props.patientsData.id !== '' && isValidBranchAwareUhid(props.patientsData.p_uhid)) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('anChartReportGenerateWrap').innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'An Chart'
            }
          };
          /*  const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment(); */

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center'}} = options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center'}} = options;
    return <th style={style}>{value}</th>;
  };
   const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };
 
  return (
    <div id='AnChart'>
      <div className='AnChart'>
        <h1>ANTENATAL INVESTIGATION CHART</h1>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Patient ID</span>
                <span style={{fontWeight: 600}}>: </span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={props.patientsData.p_uhid}
                  onChange={e => handleChange(e)}
                  name='patientId'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  color: '#000'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Gender</span>
                <span style={{fontWeight: 600}}>: </span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  value={props.patientsData.gender}
                  name='gender'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white'
                  }}>
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Others'>Others</option>
                  <option value='Decline to State'>Decline to State</option>
                </select>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>
        </div>

        <table className='table_1' border='1px' cellSpacing='0px'>
          <thead>
            <tr>
              <th>Dates</th>
              <th>Investigation</th>
              <th>Result/Value</th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                trimester: '1st Trim (0 to 12 weeks)',
                tests: [
                  'CBC',
                  'Blood Group & Rh Typing',
                  'VDRL',
                  'HIV I & II',
                  'HBsAg',
                  'HCV (if indicated)',
                  'TSH',
                  'FBS / RBS / 75g GTT',
                  'Urine Routine & Culture',
                  'Rubella IgG',
                  'Urea, Creatinine',
                  'Dual Marker',
                  'NIPT (if indicated)'
                ]
              },
              {trimester: '2nd Trim (13 to 27 weeks)', tests: ['CBC', 'Urine Routine & Culture', '75g GTT (24–28 weeks)', 'TSH (if indicated)']},
              {trimester: '3rd Trim (28 to 40 weeks)', tests: ['CBC', 'Urine Routine & Culture', 'Urea, Creatinine', 'TSH', 'BT, CT, PT, INR', 'Maternal Echo']}
            ].map((section, sectionIndex) => {
              return section.tests.map((test, testIndex) => {
                const rowIndex = `${sectionIndex}_${testIndex}`;
                return (
                  <tr key={rowIndex}>
                    {testIndex === 0 && <td rowSpan={section.tests.length}>{section.trimester}</td>}
                    <th>{test}</th>
                    <td>
                      <input type='text' name={`result_${rowIndex}`} onChange={e => handleChange(e, `result_${rowIndex}`)} className={`input createTime ${show ? 'hide' : 'show'}`} />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange[`result_${rowIndex}`]}</span>
                    </td>
                  </tr>
                );
              });
            })}
          </tbody>
        </table>

        {/* Medication Chart */}
        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='MEDICATIONS'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication')}
          />
        )}

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      {/* //* added by dani */}
      <div id='anChartReportGenerate'>
        <div id='anChartReportGenerateWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

          <div style={{marginBottom: '20px'}}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid black'
              }}>
              <thead>
                <tr>
                  <th style={{border: '1px solid black', textAlign: 'center', width: '250px'}}>Investigation</th>
                  <th style={{border: '1px solid black', textAlign: 'center'}}>Result/Value</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    label: '1st Trim (0 to 12 weeks)',
                    tests: [
                      'CBC',
                      'Blood Group & Rh Typing',
                      'VDRL',
                      'HIV I & II',
                      'HBsAg',
                      'HCV (if indicated)',
                      'TSH',
                      'FBS / RBS / 75g GTT',
                      'Urine Routine & Culture',
                      'Rubella IgG',
                      'Urea, Creatinine',
                      'Dual Marker',
                      'NIPT (if indicated)'
                    ]
                  },
                  {
                    label: '2nd Trim (13 to 27 weeks)',
                    tests: ['CBC', 'Urine Routine & Culture', '75g GTT (24–28 weeks)', 'TSH (if indicated)']
                  },
                  {
                    label: '3rd Trim (28 to 40 weeks)',
                    tests: ['CBC', 'Urine Routine & Culture', 'Urea, Creatinine', 'TSH', 'BT, CT, PT, INR', 'Maternal Echo']
                  }
                ].map((section, sectionIndex) => (
                  <React.Fragment key={`section-${sectionIndex}`}>
                    {section.label && (
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            border: '1px solid black',
                            fontWeight: 'bold',
                            padding: '8px',
                            backgroundColor: '#f0f0f0'
                          }}>
                          {section.label}
                        </td>
                      </tr>
                    )}
                    {section.tests.map((test, testIndex) => {
                      const inputName = `result_${sectionIndex}_${testIndex}`;
                      return (
                        <tr key={inputName}>
                          <td style={{border: '1px solid black', padding: '6px'}}>{test}</td>
                          <td style={{border: '1px solid black', padding: '6px'}}>
                            {}

                            <span>&nbsp;{valueChange[inputName]}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Medication Chart */}
          {showTables.medication &&

          <div style={{marginBottom: '20px'}}>
            <h3 style={{marginBottom: '10px', fontWeight: 'bold'}}>MEDICATIONS</h3>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid black'
              }}>
              <thead>
                <tr>
                  {medicationHeaders.map((header) => (
                    <th
                      key={header.key}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '8px',
                        backgroundColor: '#f0f0f0',
                        fontWeight: 'bold'
                      }}>
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {medicationRows.map((row, index) => (
                  <tr key={index}>
                    {medicationHeaders.map((header) => (
                      <td
                        key={`${index}-${header.key}`}
                        style={{
                          border: '1px solid black',
                          padding: '8px',
                          textAlign: header.key === 'sno' ? 'center' : 'left'
                        }}>
                        {row[header.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
  }

          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
